import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Button, Icon } from 'antd';
import FieldsRow from '../../../../../common/formComponents/FieldsRow/FieldsRow';
import FormDivider from '../../../../../common/formComponents/FormDivider/FormDivider';
import getTenant from '../../../../../../requests/getTenant';
import styles from './Block.module.scss';
import NameTenat from '../NameTenat/NameTenat';
import useGetAddTenantFieldsData from '../../hooks/useGetAddTenantFieldsData';
import moment from 'moment';
import { normalizeVerifiedValue } from '../../../../../../utils/normalizeVerifiedValue';

const Block = ({
  form,
  fieldKey,
  index,
  initialValues,
  onRemoveTenantField,
}) => {
  const [edited, setEdited] = useState(true);
  const [found, setFound] = useState(false);
  const [tenantData, setTenantData] = useState(initialValues);
  const [visible, setVisible] = useState(false);

  const isFirstRender = useRef(true);

  const getAddTenantFieldsData = useGetAddTenantFieldsData();

  const showSourceClientAddresses = !!tenantData?.sourceClientAddresses?.name;

  const isVerifiedValue = form.getFieldValue(`isVerified-${fieldKey}`);

  const handlePhoneChange = async (e) => {
    const value = e.target.value
      .replace(/[-,\(\)\.\s\D]/g, '')
      .substring(0, 10);

    if (value.length === 10) {
      const tenant = await getTenant(value);

      if (tenant) {
        setFound(true);
        setEdited(false);

        setTenantData(tenant);

        form.setFieldsValue({
          [`id-${fieldKey}`]: tenant.id,
          [`email-${fieldKey}`]: tenant.email,

          [`surName-${fieldKey}`]: tenant.surName,
          [`firstName-${fieldKey}`]: tenant.firstName,

          [`patrName-${fieldKey}`]: tenant.patrName,
          [`fio-${fieldKey}`]: tenant.fio,
        });
      } else {
        setFound(false);
        setEdited(true);
        setTenantData(initialValues);
      }
    } else {
      if (!edited) {
        form.resetFields([`id-${fieldKey}`]);
        form.resetFields([`surName-${fieldKey}`]);
        form.resetFields([`firstName-${fieldKey}`]);
        form.resetFields([`patrName-${fieldKey}`]);
        form.resetFields([`email-${fieldKey}`]);
        form.resetFields([`fio-${fieldKey}`]);
      }

      setFound(false);
      setEdited(true);
      setTenantData(initialValues);
    }
  };

  const handleChangeVisible = () => {
    setVisible((prev) => !prev);
  };

  const fields = useMemo(
    () =>
      getAddTenantFieldsData({
        tenantData,
        onPhoneChange: handlePhoneChange,
        isEdit: !!initialValues,
        onChangeVisible: handleChangeVisible,
        visible,
        isShowVerified: !!initialValues?.isShowVerified,
      }),
    [tenantData, initialValues, visible]
  );

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    const currentValue = normalizeVerifiedValue(isVerifiedValue);

    if (currentValue === initialValues?.isVerified) {
      form.setFieldsValue({
        [`verificationDate-${fieldKey}`]:
          moment(initialValues?.verificationDate).format('DD.MM.YYYY') || '',
      });

      return;
    }

    if (currentValue === null) {
      form.setFieldsValue({
        [`verificationDate-${fieldKey}`]: '',
      });

      return;
    }

    form.setFieldsValue({
      [`verificationDate-${fieldKey}`]: moment().format('DD.MM.YYYY'),
    });
  }, [isVerifiedValue, initialValues]);

  return (
    <>
      {index !== 0 && <FormDivider />}
      {found && (
        <div className={styles.foundContainer}>
          <Icon
            type="check-circle"
            theme="filled"
            className={styles.foundIcon}
          />
          <p className={styles.foundText}>
            Пользователь с таким номером телефона уже существует в системе
          </p>
        </div>
      )}
      {showSourceClientAddresses && (
        <NameTenat
          title="Источник привязки собственника:"
          value={tenantData?.sourceClientAddresses?.name}
        />
      )}
      {Boolean(tenantData?.name) && (
        <NameTenat
          title="Псевдоним, введенный в МП собственника:"
          value={tenantData?.name}
        />
      )}
      <FieldsRow
        form={form}
        gutter={[10, 28]}
        rowType="subtitle"
        index={fieldKey}
        fields={fields}
      />
      {index !== 0 && (
        <Button
          type="danger"
          icon="delete"
          ghost
          onClick={() => onRemoveTenantField(fieldKey)}
        >
          Удалить жильца
        </Button>
      )}
    </>
  );
};

export default Block;
